// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J32cJa{display:flex;flex-direction:column-reverse;width:180px;height:90px;border:2px solid rgba(0,0,0,0.5);border-radius:2px;background-color:rgba(0,0,0,0.5);align-items:center}.J32cJa.C81HG6{width:initial;height:initial;border:none;border-radius:0}.dpQKPi,.biJKvA{position:absolute;top:2px;right:2px;bottom:2px;left:2px;width:180px;height:90px}.dpQKPi{z-index:2}.biJKvA{z-index:1}.C81HG6 .hdwGam{background:none}.C81HG6 .dpQKPi,.C81HG6 .biJKvA{width:0;height:0}.hdwGam{font-size:11px;line-height:12px;position:relative;z-index:3;padding:4px 5px;white-space:nowrap;color:white;background:rgba(0,0,0,0.8)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `J32cJa`,
	"empty": `C81HG6`,
	"highQualityFrame": `dpQKPi`,
	"lowQualityFrame": `biJKvA`,
	"thumbText": `hdwGam`
};
export default ___CSS_LOADER_EXPORT___;
